module.exports = __webpack_public_path__ + "static/media/pensionfund.ed78d85c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/pensionfund.svg
// module id = 544
// module chunks = 0